import React from "react";
import { Link } from "gatsby";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";

export default ({ code, id, title, details, upvotes, downvotes, upvoted, downvoted, closedAt, handleVote, authenticated }) => (
    <div css={{
        display: "flex",
        alignItems: "flex-start",
        transition: "background-color var(--transition-default-time) ease-in-out",
        ":hover": {
            borderRadius: 3,
            backgroundColor: "rgba(100, 100, 100, .05)",
        },
    }}>
        <div css={{
            margin: 15,
            display: "flex",
            flexDirection: "column",
        }}>
            <div
                css={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    color: upvoted ? "var(--green)" : "inherit",
                    transition: "color var(--transition-default-time) ease-in-out",
                    cursor: authenticated ? "pointer" : "not-allowed",
                    ":hover": {
                        color: "var(--green)",
                    },
                }}
                onClick={ () => authenticated ? upvoted ? handleVote(0) : handleVote(1) : null }
            >
                <IoIosArrowUp />
            </div>
            <div css={{
                fontSize: ".9em",
                textAlign: "center",
            }}>
                { (upvotes || 0) - (downvotes || 0) }
            </div>
            <div
                css={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    color: downvoted ? "var(--red)" : "inherit",
                    transition: "color var(--transition-default-time) ease-in-out",
                    cursor: authenticated ? "pointer" : "not-allowed",
                    ":hover": {
                        color: "var(--red)",
                    },
                }}
                onClick={ () => authenticated ? downvoted ? handleVote(0) : handleVote(-1) : null }
            >
                <IoIosArrowDown />
            </div>
        </div>

        <Link
            to={ "/" + code + "/feedback/" + id }
            css={{
                width: "100%",
                marginTop: 15,
                marginBottom: 15,
                display: "flex",
                flexDirection: "column",
                cursor: "pointer",
            }}
        >
            <div css={{
                fontWeight: 500,
                marginBottom: 10,
            }}>
                { title }
            </div>

            <div css={{
                marginBottom: 10,
                fontSize: ".8em",
                fontWeight: 500,
                textTransform: "uppercase",
                color: closedAt ? "var(--red)" : "var(--blue)",
            }}>
                { closedAt ? "Closed" : "Open" }
            </div>

            {
                details && details.length
                ?   <div css={{
                        color: "lightgrey",
                        fontSize: ".9em",
                    }}>
                        { details.length > 256 ? details.slice(0, 256) + "..." : details }
                    </div>
                :   null
            }
        </Link>
    </div>
);
